// extracted by mini-css-extract-plugin
export default {"container":"isKMwi","divider":"j9X_4N"};